import { render } from "./StampTable.vue?vue&type=template&id=093778b4&scoped=true"
import script from "./StampTable.vue?vue&type=script&lang=js"
export * from "./StampTable.vue?vue&type=script&lang=js"

import "./StampTable.vue?vue&type=style&index=0&id=093778b4&scoped=true&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093778b4"]])

export default __exports__